import SetupFlowTapToPayLarge from 'assets/images/setup-flow/setup-flow-tap-to-pay-large.jpg'
import SetupFlowTapToPayMedium from 'assets/images/setup-flow/setup-flow-tap-to-pay-medium.jpg'
import SetupFlowTapToPaySmall from 'assets/images/setup-flow/setup-flow-tap-to-pay-small.jpg'

export const getPreLoadImages = () => {
  return [
    SetupFlowTapToPaySmall,
    SetupFlowTapToPayMedium,
    SetupFlowTapToPayLarge,
  ]
}
